import type { AxiosRequestConfig } from "axios";
import type { IAddresses, IPlaceDetailsResult } from "@/types/address";
import type { IRepositoryOptions } from "@/types/common";
import { BaseRepository } from "../BaseRepository";
import type { AddressService } from "./service";
import type { IGetAddressDetailsRequest, IGetAddressesRequest } from "./types";

export class AddressRepository extends BaseRepository {
  constructor(
    private readonly service: AddressService,
    options?: IRepositoryOptions,
  ) {
    super(options);
  }

  async getAddresses(
    p: IGetAddressesRequest,
    c?: AxiosRequestConfig,
  ): Promise<IAddresses> {
    const response = await this.handleRequest(this.service.getAddresses, p, c);
    return response.data;
  }

  async getAddressDetails(
    p: IGetAddressDetailsRequest,
    c?: AxiosRequestConfig,
  ): Promise<IPlaceDetailsResult> {
    const response = await this.handleRequest(
      this.service.getAddressDetails,
      p,
      c,
    );
    return response.data;
  }
}
